import { render, staticRenderFns } from "./DataVisualizer.vue?vue&type=template&id=51e2324c&scoped=true&"
import script from "./DataVisualizer.vue?vue&type=script&lang=ts&"
export * from "./DataVisualizer.vue?vue&type=script&lang=ts&"
import style0 from "./DataVisualizer.vue?vue&type=style&index=0&id=51e2324c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e2324c",
  null
  
)

export default component.exports